import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Image } from 'UI-Dash-Commons-UI';

type TitleCardProps =
    {
        alt: string,
        displayName: string,
        imageSrc: string,
        url: string,
    };

const TitleCard: React.FunctionComponent<TitleCardProps> = ( props: TitleCardProps ) =>
    (
        <TitleCardWrapper
            to={props.url}
        >
            <ImageWrapper
                alt={props.alt}
                src={props.imageSrc}
            />
            <Title>
                {props.displayName}
            </Title>
        </TitleCardWrapper>
    );

export default TitleCard;

const TitleCardWrapper = styled( Link )`
  display: inline-block;

  width: 228px;

  margin: 60px 30px 100px 0px;
  padding: 24px 0;

  text-decoration: none;
  border: 1px solid ${props => props.theme.colors.blueLight};

  transition: transform 300ms ease-out;

  :hover {
    transform: translate(0px, -3px);
    background: ${props => props.theme.colors.backgroundBlueLight};
  }
`;

const ImageWrapper = styled( Image )`
  display: block;
  
  width: 134px;
  height: 134px;
  
  margin: auto;
`;

const Title = styled.div`
  display: block;

  margin-top: 16px;

  text-align: center;

  font-family: ${props => props.theme.fonts.demi};
  font-size: 18px;

  color: ${props => props.theme.colors.textBlue};
`;
